import React from 'react';

import StyledLottie from './LottieAnimation.styles';

import circleLoader from 'src/ui/assets/lottieAnimations/circleLoader.json';
import inDevelopmentPlaceholder from 'src/ui/assets/lottieAnimations/inDevelopmentPlaceholder.json';
import notFound from 'src/ui/assets/lottieAnimations/notFound.json';

const ANIMATIONS = {
  circleLoader,
  inDevelopmentPlaceholder,
  notFound,
};

const LottieAnimation: React.FC<{
  animation: keyof typeof ANIMATIONS;
  className?: string;
  style?: React.CSSProperties;
}> = (props) => {
  return (
    <StyledLottie
      animationData={ANIMATIONS[props.animation]}
      className={props.className}
      style={props.style}
    />
  );
};

export default LottieAnimation;
